import React from 'react'
import FoodGrid from '../components/food-grid/FoodGrid';
import PageHeader from '../components/page-header/PageHeader';

const FoodCatalog = () => {
    return (
        <div>
            <PageHeader>Foods</PageHeader>
            <div className="container">
                <div className="section mb-3">
                    <FoodGrid />
                </div>
            </div>
        </div>
    )
}

export default FoodCatalog